export const items = [
  {
    id: 1,
    name: "Classic Matcha Latte",
    price: 289,
    type: "veg",
    category: "Matcha (Hot)",
    description:
      "Creamy milk blended with ceremonial grade matcha. Smooth, rich, and perfectly balanced.",
  },
  {
    id: 2,
    name: "Vanilla Matcha Latte",
    price: 299,
    type: "veg",
    category: "Matcha (Hot)",
    description:
      "Matcha with steamed milk and a touch of vanilla syrup. Lightly sweet and aromatic.",
  },
  {
    id: 3,
    name: "Classic Caesar Salad",
    price: 259,
    type: "veg",
    category: "Salads",
    description:
      "Crisp iceberg lettuce tossed in a rich, creamy Caesar dressing. A refreshing classic.",
  },
  {
    id: 4,
    name: "Paneer Caesar Salad",
    price: 299,
    type: "veg",
    category: "Salads",
    description:
      "A decadent twist on the classic Caesar salad featuring marinated paneer cubes.",
  },
  {
    id: 5,
    name: "Crispy Potato Balls",
    price: 249,
    type: "veg",
    category: "Quick Bites (Veg)",
    description:
      "Crispy batter-coated potato balls served hot. Perfect for a light, savory snack.",
  },
  {
    id: 6,
    name: "Momos (Veg)",
    price: 129,
    type: "veg",
    category: "Matcha",
    description: "Steamed dumplings filled with a savory vegetable mix, served with spicy chutney.",
  },
  {
    id: 7,
    name: "Kenley Water Bottle",
    price: 25,
    type: "veg",
    category: "Water Bottle",
    description:
      "1 Liter Water Bottle.",
  },
  {
    id: 8,
    name: "Bislari Water Bottle",
    price: 25,
    type: "veg",
    category: "Water Bottle",
    description:
      "1 Liter Water Bottle.",
  },
  {
    id: 9,
    name: "Venilla Milkshake",
    price: 49,
    type: "veg",
    category: "Milkshakes",
    description:
      "Venilla Milkshake blended with chocolate cream and venilla drops.",
  },
  {
    id: 10,
    name: "Crispy Chicken Balls",
    price: 249,
    type: "nonveg",
    category: "Quick Bites (Non-Veg)",
    description:
      "Crispy chicken balls served hot. Perfect for a light, savory snack.",
  },
  {
    id: 11,
    name: "Veg Soup",
    price: 89,
    type: "veg",
    category: "Appetizers (Veg)",
    description:
      "A warm bowl of mixed vegetable soup, seasoned to perfection.",
  },
  {
    id: 12,
    name: "Chicken Soup",
    price: 119,
    type: "nonveg",
    category: "Appetizers (Non-Veg)",
    description: "A hearty bowl of chicken soup with tender pieces of chicken and vegetables.",
  },
]

export const categories = [
    "Salads",
    "Quick Bites (Veg)",
    "Quick Bites (Non-Veg)",
    "Appetizers (Veg)",
    "Appetizers (Non-Veg)",
    "Water Bottle",
    "Matcha",
    "Milkshakes",
    "Matcha (Hot)",
]

export const page3BGColor = "#edededff"

export const theamOrange = "#ff8a2b"